export enum PayoutStatus {
  NOT_IN_PAYOUT = "NOT_IN_PAYOUT",
  IN_PAYOUT = "IN_PAYOUT",
  PAID_OUT_HAS_BALANCE = "PAID_OUT_HAS_BALANCE",
  COMPLETELY_PAID_OUT = "COMPLETELY_PAID_OUT",
}
